import script from "./ProductCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCategory.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCategory.vue?vue&type=style&index=0&id=4b5ed198&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5ed198"]])

export default __exports__